<template >

  <div class="container " >
    <form action="" @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h6><i class="fa fa-address-book"></i><span class="tab-txt"> البيانات الاساسية </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
         
            <div class="form-group col-md-3">
              <label for="">رقم اللوحة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.boardNum.$model"
                :class="{
                  'is-invalid': $v.boardNum.$error,
                  'is-valid': !$v.boardNum.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.boardNum.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.boardNum.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.boardNum.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.boardNum.maxLength"
                  >اقصى عدد مسموح {{ $v.boardNum.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">ماركة الباص</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.busName.$model"
                :class="{
                  'is-invalid': $v.busName.$error,
                  'is-valid': !$v.busName.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.busName.required">هذا الحقل مطلوب</span>
              
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">موديل الباص</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.busModel.$model"
                :class="{
                  'is-invalid': $v.busModel.$error,
                  'is-valid': !$v.busModel.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.busModel.required">هذا الحقل مطلوب</span>
             
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">عدد المقاعد</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.busSeats.$model"
                :class="{
                  'is-invalid': $v.busSeats.$error,
                  'is-valid': !$v.busSeats.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.busSeats.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.busSeats.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.busSeats.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.busSeats.maxLength"
                  >اقصى عدد مسموح {{ $v.busSeats.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>

           
            <div class="form-group col-md-3">
              <label for="">اللون</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.busColor.$model"
                :class="{
                  'is-invalid': $v.busColor.$error,
                  'is-valid': !$v.busColor.$invalid,
                }"
              />
              <div class="invalid-feedback">
              </div>
            </div>
    

             <div class="form-group col-md-3">
              <label for="">تاريخ الاصدار</label>
             
              <input
                id="busDate"
                type="text"
                @blur="busDate1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.busDate.$model"
                :class="{
                  'is-invalid': $v.busDate.$error,
                  'is-valid': !$v.busDate.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.busDate.required">هذا الحقل مطلوب</span>
              </div>
            </div>

     
 <div class="form-group col-md-3">
              <label for="">تاريخ بداية الرخصة </label>
             
              <input
                id="lcStart"
                type="text"
                @blur="lcStart1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.lcStart.$model"
                :class="{
                  'is-invalid': $v.lcStart.$error,
                  'is-valid': !$v.lcStart.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.lcStart.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-3">
              <label for="">تاريخ نهاية الرخصة </label>
             
              <input
                id="lcEnd"
                type="text"
                @blur="lcEnd1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.lcEnd.$model"
                :class="{
                  'is-invalid': $v.lcEnd.$error,
                  'is-valid': !$v.lcEnd.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.lcEnd.required">هذا الحقل مطلوب</span>
              </div>
            </div>

   

          </div>
        </div>
      </div>
       <div class="card">
     <!--    <div class="card-header">
            <h6><i class="fa fa-database"></i><span class="tab-txt"> بيانات التعاقد </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
       <div class="form-group col-md-3">
              <label for="">المالك</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.ownerBus.$model"
                :class="{
                  'is-invalid': $v.ownerBus.$error,
                  'is-valid': !$v.ownerBus.$invalid,
                }"
              >
             <option v-for="emp in emps" :value="emp.id" :key="emp.id">
           <span> {{ emp.Fname }} </span> <span> {{ emp.Ffname }} </span>
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.ownerBus.required">هذا الحقل مطلوب</span>
              </div>
            </div>

        <div class="form-group col-md-3">
              <label for="">رقم التعاقد</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.contractNum.$model"
                :class="{
                  'is-invalid': $v.contractNum.$error,
                  'is-valid': !$v.contractNum.$invalid,
                }"
              />
              <div class="invalid-feedback">

              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">خط السير من</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.trafficFrom.$model"
                :class="{
                  'is-invalid': $v.trafficFrom.$error,
                  'is-valid': !$v.trafficFrom.$invalid,
                }"
              >
             <option v-for="workarea in workarea" :value="workarea.id" :key="workarea.id">
           {{ workarea.areaName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.trafficFrom.required">هذا الحقل مطلوب</span>
              </div>
            </div>

             <div class="form-group col-md-3">
              <label for="">خط السير الى </label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.trafficTo.$model"
                :class="{
                  'is-invalid': $v.trafficTo.$error,
                  'is-valid': !$v.trafficTo.$invalid,
                }"
              >
             <option v-for="traffic in traffic" :value="traffic.id" :key="traffic.id">
           {{ traffic.trafficTo }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.trafficTo.required">هذا الحقل مطلوب</span>
              </div>
            </div>
 

          </div>
        </div> -->
        <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-cog"></i><span class="tab-txt"> التحكم </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="submitStatus === 'انتظار'"
              >
              <b-spinner
v-if="busy"
small
type="grow"
style="margin-bottom: 3px;"
></b-spinner>
              <i class="fa fa-paper-plane"></i>
               <span> {{submitStatus}} </span>
              </button>
               <b-button
                class="btn btn-info mr-3"
                type="button"
                to="/buses"
              >
              <i class="fa fa-undo"></i>
               <span> عودة </span>
              </b-button>
            </div>
          </div>
        </div>
      </div> 
    </form>

  </div>
</template>





<script>
  import { mapState,mapActions  } from 'vuex';
 import $ from 'jquery'
import indexLayout from "../../layouts/indexLayout.vue";


import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
export default {
  name: "createEmp",
  data() {
    return {
busSeats:"",
boardNum:"",
lcStart:"",
lcEnd:"",
busColor:"",
busDate:"",
busModel:"",
busName:"",
ownerBus:1,
trafficFrom:1,
trafficTo:1,
contractNum:0,
busy:false,
      submitStatus: "حفظ",
    };
  },
  validations: {
    
    boardNum: { required, minLength: minLength(2), maxLength: maxLength(25) },
    busSeats: { required, minLength: minLength(2), maxLength: maxLength(25) },
    busColor: {  },
    busName: { required },
    busModel: { required },
    ownerBus: {  },
    contractNum: {  },

    trafficFrom: {  },
    trafficTo: {  },
 
    lcStart: { 
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
    lcEnd: { 
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
     busDate: { 
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    }
  

  },
  methods: {
   ...mapActions('busMod',['addData']),
  busDate1(){
        var st = $('#busDate').val();
        this.busDate = st;
   },
  lcStart1(){
        var st = $('#lcStart').val();
        this.lcStart = st;
   },  lcEnd1(){
        var ed = $('#lcEnd').val();
        this.lcEnd = ed;
   },
   async submit() {
      this.$v.$touch();
      this.busy=true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy=false;
      } else {
       var std = {
 busSeats:this.busSeats,
boardNum:this.boardNum,
lcStart:this.lcStart,
lcEnd:this.lcEnd,
busColor:this.busColor,
busDate:this.busDate,
busModel:this.busModel,
busName:this.busName,
ownerBus:this.ownerBus,
trafficFrom:this.trafficFrom,
trafficTo:this.trafficTo,
contractNum:this.contractNum,
}
         await  this.addData(std);       

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.submitStatus = "تم الحفظ";
        }, 500);
        this.busy=false;
      }
    },
  },created(){

let ckeditor = document.createElement('script'); 
//ckeditor.setAttribute('src',"/load.js");
ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
document.head.appendChild(ckeditor);
 this.$emit('update:layout',indexLayout)


  }
  ,mounted(){
    
  
  },
  computed: mapState([
     'emps',            
    'workarea',
    'traffic' 
  ])
};
</script>

<style lang="scss" scoped>
span{
  font-size: 12px;
}
</style>
